import api from "@/lib/api";

/**
 * Open a document in a new tab using a short-lived signed URL.
 * Falls back to alerting on failure.
 */
export async function openSignedDocument(docId) {
  try {
    const { data } = await api.get(`/documents/${docId}/signed-url`);
    if (!data?.url) throw new Error("No signed URL returned");
    const backend = process.env.REACT_APP_BACKEND_URL || "";
    const absolute = data.url.startsWith("http") ? data.url : `${backend}${data.url}`;
    window.open(absolute, "_blank", "noopener,noreferrer");
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Failed to open document:", e);
    throw e;
  }
}
